<template>
    <div>
        <a-card title="硬件分析">
            <div style="margin-bottom:18px;">
                <div>
                    <envSelecter v-model="selectedEnv" style="display:inline-flex;"></envSelecter>
                    <sysSelecter v-model="sleectedSys" style="display:inline-flex;"></sysSelecter>
                    <timeSelecter v-model="selectedTimeRange" style="margin-left:20px;"></timeSelecter>
                    <a-button type="primary" style="margin-left:20px;" @click="handleSubmit">查询</a-button>
                </div>
            </div>
            <a-row :gutter="[16,16]">
                <a-col :span='12'>
                    <posWarn ref="posWarnID"></posWarn>

                </a-col>

                <a-col :span='12'>
                    <posWarnTable ref="posWarnTableID"></posWarnTable>
                </a-col>
            </a-row>
            <a-row :gutter="[16,16]">
                <a-col :span='12'>
                    <posCallBack ref="posCallBackID"></posCallBack>
                </a-col>

            </a-row>
        </a-card>

    </div>
</template>

<script>
import sysSelecter from '../components/sysSelecter'
import envSelecter from '../components/envSelecter'
import timeSelecter from '../components/timeselecter'

import posWarn from './posWarnChart'
import posCallBack from './posCallBackPie'
import posWarnTable from './posWarnTable'

export default {
    data(){
        return {
            sleectedSys:'',
            selectedEnv:'',
            selectedTimeRange:'',
        }
    },
    methods:{
        handleSubmit(){

            this.$refs.posWarnID.loadData(this.selectedEnv,this.sleectedSys,this.selectedTimeRange);
            this.$refs.posCallBackID.loadData(this.selectedEnv,this.sleectedSys,this.selectedTimeRange,1);
            this.$refs.posWarnTableID.loadData(this.selectedEnv,this.sleectedSys,this.selectedTimeRange);
        },
 
    },
    mounted(){
        this.handleSubmit()
    },
    destroyed(){
    },
    components:{
        sysSelecter,
        envSelecter,
        timeSelecter,
        posWarn,
        posCallBack,
        posWarnTable,
    }
};
</script>

<style lang="less" scoped>
</style>
<style>

</style>